// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2UXgZ","actionsCol":"EnrolledClinics_actionsCol__2wsrH"};